import { default as BSDropdown } from 'bootstrap/js/src/dropdown'

class Dropdown extends BSDropdown {}

export default Dropdown
